import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Layout from './Layout'

const RequiredAuth = (props) => {

  const { allowedRoles } = props
  const auth = useSelector((state) => state.auth)
  const location = useLocation()

  return (
    allowedRoles?.find(r => auth?.value?.user?.role.includes(r))
      ? <Layout />
      : auth.value.isLoggedIn
        ? <Navigate to='/' state={{ from: location }} />
        : <Navigate to='/login' state={{ from: location }} />
  )
}

export default RequiredAuth